import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, Row, Table } from "react-bootstrap";
import { SearchIcon } from '@primer/octicons-react'
import { BiCalendar, BiXCircle } from "react-icons/bi";
import LocPickerDialog from './LocPickerDialog';
import DateTimePicker from 'react-datetime-picker';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_ASSET_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import configInfo from '../config/config.json';


const AssetAdminNewView = (props) => {

  // Utilities
  const { i18n, t } = useTranslation(['common', 'custom']);
  const locale = i18n.language.replace("_", "-");

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    id: '',
    code: '',
    name: '',
    nameLang2: '',
    nameLang3: '',
    description: '',
    nativeCode: '',
    typeid: null,
    typeCode: '',
    locId: null,
    locCode: '',
    serviceLocId: null,
    serviceLocCode: '',
    mfr: '',
    bimGuid: '',
    rfidTag: '',
    iotCode: '',
    photo: '',
    brand: '',
    model: '',
    modelNum: '',
    serialNum: '',
    aaa: '',
    length: null,
    width: null,
    height: null,
    weight: null,
//    mfrDate: '',
    installDate: '',
    status: '',
    updatedBy: '',
    timeUpdated: '',
    createdBy: '',
    timeCreated: ''
  });


  const [typeSpecAttrList,     setTypeSpecAttrList]     = useState([]);
  const [typeSpecAttrs,        setTypeSpecAttrs]        = useState([]);
//  const [docList,              setDocList]              = useState([]);

  const [handoverDate,         setHandoverDate]         = useState(null);
  const [installDate,          setInstallDate]          = useState(null);
  const [firstUseDate,         setFirstUseDate]         = useState(null);
  const [warrStartDate,        setWarrStartDate]        = useState(null);
  const [warrEndDate,          setWarrEndDate]          = useState(null);

  const [showTypeSelectDialog, setShowTypeSelectDialog] = useState(false);
  const [typeSearchTerm,       setTypeSearchTerm]       = useState('');
  const [typeList,             setTypeList]             = useState('');
  const [errMsg_TypeSelect,    setErrMsg_TypeSelect]    = useState('');

  const [locPickerMode,        setLocPickerMode]        = useState(null);
  const [showLocPickerDialog,  setShowLocPickerDialog]  = useState(false);

  const [errMsg,               setErrMsg]               = useState('');

  // UI Functions

  // Initialize state
  useEffect(() => {

     fetchTypeSpecAttrList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchTypeSpecAttrList = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.get("business-configs?name=OBJ_TYPE_SPECIFIC_ATTRS");

        resolve(res.data);
        if (res.status === 200) {

          if (   res.data
              && res.data[0]
              && res.data[0].config
              && res.data[0].config.ASSET) {

            setTypeSpecAttrList (res.data[0].config.ASSET);
/*
setTypeSpecAttrs([
'pumpHead',
'pumpWaterFlow',
'motorPower',
'motorSpeed',
'coolingCap',
'evapFlowRate',
'condFlowRate',
'cop',
'heatRejection',
'waterFlowRate',
'airFlowRate',
'staticPressure',
'ratedLoad',
'ratedSpeed',
'powerRange'
]);
*/
          }
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

/*
  const fetchDocs = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.get("asset/" + id + "/docs");

        resolve(res.data);
        if (res.status === 200) {
          setDocList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }
*/

  const statusList = [
    { key: "IN_USE",   value: "IN_USE" },
    { key: "IDLE",     value: "IDLE" },
    { key: "DISPOSED", value: "DISPOSED" }
  ];


  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const onDatepickerChangeHandoverDate = (value) => {
    setHandoverDate(value);
  }

  const onDatepickerChangeInstallDate = (value) => {
    setInstallDate(value);
  }

  const onDatepickerChangeFirstUseDate = (value) => {
    setFirstUseDate(value);
  }

  const onDatepickerChangeWarrStartDate = (value) => {
    setWarrStartDate(value);
  }

  const onDatepickerChangeWarrEndDate = (value) => {
    setWarrEndDate(value);
  }

  const onAssetStatusSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, status: key })
  };


  const handleCreateSubmit = (e) => {
    e.preventDefault();

    let currentTime = (new Date()).getTime();

    // Validate form inputs
    if (!objAttrs.code || objAttrs.code.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_code"));
      return;
    } else if (objAttrs.code.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_code") + 50);
      return;

    } else if (!objAttrs.name || objAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
      return;
    } else if (objAttrs.name.length > 100) {
      setErrMsg(t("I18N_Name") + " - " + t("I18N_ERR_Max_len") + "100");
      return;

/*
    } else if (!objAttrs.nameLang2 || objAttrs.nameLang2.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_2") + ")");
      return;
*/
    } else if (objAttrs.nameLang2.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;

/*
    } else if (!objAttrs.nameLang3 || objAttrs.nameLang3.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name") + " (" + t("custom:I18N_Language_3") + ")");
      return;
*/
    } else if (objAttrs.nameLang3.length > 100) {
      setErrMsg(t("I18N_Name") + " (" + t("custom:I18N_Language_3") + ") - " + t("I18N_ERR_Max_len") + "100");
      return;

    } else if (objAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + "200");
      return;

    } else if (!objAttrs.typeCode || objAttrs.typeCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_asset_type"));
      return;

    } else if (objAttrs.code.indexOf(objAttrs.typeCode) < 0) {
      setErrMsg(t("I18N_ERR_Asset_code_must_contain_type"));
      return;

    } else if (objAttrs.nativeCode.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_native_code") + "50");
      return;

/* Not required
    } else if (!objAttrs.locCode || objAttrs.locCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_loc"));
      return;

    } else if (!objAttrs.typeCode || objAttrs.typeCode.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_serv_loc"));
      return;
*/

    } else if (objAttrs.brand && objAttrs.brand.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_brand") + "100");
      return;

    } else if (objAttrs.model && objAttrs.model.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_model") + "100");
      return;

    } else if (objAttrs.modelNum && objAttrs.modelNum.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_model_num") + "50");
      return;

    } else if (objAttrs.serialNum && objAttrs.serialNum.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_serial_num") + "50");
      return;

    } else if (objAttrs.mfr && objAttrs.mfr.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_mfr") + "100");
      return;

    } else if (objAttrs.website && objAttrs.website.length > 1000) {
      setErrMsg(t("I18N_ERR_Max_len_website") + "1000");
      return;

    } else if (objAttrs.countryOfOrigin && objAttrs.countryOfOrigin.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_country_of_orig") + "100");
      return;

    } else if (objAttrs.vendor && objAttrs.vendor.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_vendor") + "100");
      return;

    } else if (objAttrs.length && (objAttrs.length.length > 0) &&
               (!isNaturalNumber(objAttrs.length) || (objAttrs.length > 2147483647))) {
      setErrMsg(t("I18N_Length") + t("I18N_ERR_Must_be_pos_int_and_LT") + '2,147,483,648.');
      return;

    } else if (objAttrs.width && (objAttrs.width.length > 0) &&
               (!isNaturalNumber(objAttrs.width) || (objAttrs.width > 2147483647))) {
      setErrMsg(t("I18N_Width") + t("I18N_ERR_Must_be_pos_int_and_LT") + '2,147,483,648.');
      return;

    } else if (objAttrs.height && (objAttrs.height.length > 0) &&
               (!isNaturalNumber(objAttrs.height) || (objAttrs.height > 2147483647))) {
      setErrMsg(t("I18N_Height") + t("I18N_ERR_Must_be_pos_int_and_LT") + '2,147,483,648.');
      return;

    } else if (objAttrs.weight && (objAttrs.weight.length > 0) &&
               (!isNaturalNumber(objAttrs.weight) || (objAttrs.weight > 2147483647))) {
      setErrMsg(t("I18N_Weight") + t("I18N_ERR_Must_be_pos_int_and_LT") + '2,147,483,648.');
      return;

    } else if (objAttrs.pumpHead && (objAttrs.pumpHead.length > 0) && isNaN(objAttrs.pumpHead)) {
      setErrMsg(t("I18N_pumpHead") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.pumpWaterFlow && (objAttrs.pumpWaterFlow.length > 0) && isNaN(objAttrs.pumpWaterFlow)) {
      setErrMsg(t("I18N_pumpWaterFlow") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.motorPower && (objAttrs.motorPower.length > 0) && isNaN(objAttrs.motorPower)) {
      setErrMsg(t("I18N_motorPower") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.motorSpeed && (objAttrs.motorSpeed.length > 0) && isNaN(objAttrs.motorSpeed)) {
      setErrMsg(t("I18N_motorSpeed") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.coolingCap && (objAttrs.coolingCap.length > 0) && isNaN(objAttrs.coolingCap)) {
      setErrMsg(t("I18N_coolingCap") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.evapFlowRate && (objAttrs.evapFlowRate.length > 0) && isNaN(objAttrs.evapFlowRate)) {
      setErrMsg(t("I18N_evapFlowRate") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.condFlowRate && (objAttrs.condFlowRate.length > 0) && isNaN(objAttrs.condFlowRate)) {
      setErrMsg(t("I18N_condFlowRate") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.cop && (objAttrs.cop.length > 0) && isNaN(objAttrs.cop)) {
      setErrMsg(t("I18N_cop") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.heatRejection && (objAttrs.heatRejection.length > 0) && isNaN(objAttrs.heatRejection)) {
      setErrMsg(t("I18N_heatRejection") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.waterFlowRate && (objAttrs.waterFlowRate.length > 0) && isNaN(objAttrs.waterFlowRate)) {
      setErrMsg(t("I18N_waterFlowRate") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.airFlowRate && (objAttrs.airFlowRate.length > 0) && isNaN(objAttrs.airFlowRate)) {
      setErrMsg(t("I18N_airFlowRate") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.staticPressure && (objAttrs.staticPressure.length > 0) && isNaN(objAttrs.staticPressure)) {
      setErrMsg(t("I18N_staticPressure") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.ratedLoad && (objAttrs.ratedLoad.length > 0) && isNaN(objAttrs.ratedLoad)) {
      setErrMsg(t("I18N_ratedLoad") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.ratedSpeed && (objAttrs.ratedSpeed.length > 0) && isNaN(objAttrs.ratedSpeed)) {
      setErrMsg(t("I18N_ratedSpeed") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (objAttrs.powerRange && (objAttrs.powerRange.length > 0) && isNaN(objAttrs.powerRange)) {
      setErrMsg(t("I18N_powerRange") + t("I18N_ERR_Must_be_a_num"));
      return;

    } else if (!objAttrs.status || (objAttrs.status.length === 0)) {
      setErrMsg(t("I18N_ERR_Need_status"));
      return;

    } else if (handoverDate && ((handoverDate.getTime() - currentTime) > 0)) {
      setErrMsg(t("I18N_handoverDate") + t("I18N_ERR_Date_must_be_in_past"));
      return;

    } else if (installDate && ((installDate.getTime() - currentTime) > 0)) {
      setErrMsg(t("I18N_installDate") + t("I18N_ERR_Date_must_be_in_past"));
      return;

    } else if (firstUseDate && ((firstUseDate.getTime() - currentTime) > 0)) {
      setErrMsg(t("I18N_firstUseDate") + t("I18N_ERR_Date_must_be_in_past"));
      return;

    } else if (warrStartDate && ((warrStartDate.getTime() - currentTime) > 10 * 356 * 24 * 60 * 60 * 1000)) {
      setErrMsg(t("I18N_warrStartDate") + t("I18N_ERR_Date_10_yr_in_future_limit"));
      return;

    } else if (warrEndDate && ((warrEndDate.getTime() - currentTime) > 10 * 356 * 24 * 60 * 60 * 1000)) {
      setErrMsg(t("I18N_warrEndDate") + t("I18N_ERR_Date_20_yr_in_future_limit"));
      return;

    } else if (warrStartDate && warrEndDate && (warrEndDate.getTime() < warrStartDate.getTime())) {
      setErrMsg(t("I18N_ERR_Warr_End_GT_Start_time"));
      return;
    }

    // Deep copy
    let tmpAttrs = JSON.parse(JSON.stringify(objAttrs));
    tmpAttrs.raw = null;

    // Get the date type attributes
    tmpAttrs.handoverDate  = handoverDate;
    tmpAttrs.installDate   = installDate;
    tmpAttrs.firstUseDate  = firstUseDate;
    tmpAttrs.warrStartDate = warrStartDate;
    tmpAttrs.warrEndDate   = warrEndDate;

/*
    tmpAttrs.mfrDate       = (mfrDate       ? mfrDate.toISOString()       : "");
*/
    tmpAttrs.handoverDate  = (handoverDate  ? handoverDate.toISOString()  : "");
    tmpAttrs.installDate   = (installDate   ? installDate.toISOString()   : "");
    tmpAttrs.firstUseDate  = (firstUseDate  ? firstUseDate.toISOString()  : "");
    tmpAttrs.warrStartDate = (warrStartDate ? warrStartDate.toISOString() : "");
    tmpAttrs.warrEndDate   = (warrEndDate   ? warrEndDate.toISOString()   : "");

    tmpAttrs.length        = objAttrs.length && (objAttrs.length.length > 0) ? (objAttrs.length * 1.0) : null;
    tmpAttrs.height        = objAttrs.height && (objAttrs.height.length > 0) ? (objAttrs.height * 1.0) : null;
    tmpAttrs.width         = objAttrs.width  && (objAttrs.width.length  > 0) ? (objAttrs.width  * 1.0) : null;
    tmpAttrs.weight        = objAttrs.weight && (objAttrs.weight.length > 0) ? (objAttrs.weight * 1.0) : null;

    // Initial status for alarm suspension is NO
    tmpAttrs.almSuspStatus = "NO";

    const reqBody = tmpAttrs;

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.post("assets", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          props.onUIMode('LIST')
          setErrMsg('');
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  const handleCreateCancel = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  // --- Asset type select dialog stuff ---

  const handleTypePicker = (e) => {
    setErrMsg_TypeSelect('');
    setShowTypeSelectDialog(true);
  }

  const handleTypeSearch = (e) => {
    e.preventDefault();

    if (typeSearchTerm === '') {
      setTypeSearchTerm('');
      setTypeList([]);
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.get("asset-types?searchTerms=" + typeSearchTerm);

        resolve(res.data);

        if (res.status === 200) {
          setTypeList(res.data.data);
        }

        setErrMsg_TypeSelect('');
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_TypeSelect(t(translateAPIError(error)));
        }
      }
    });

  }

  function handleTypeSelectCancel() {
    setErrMsg_TypeSelect('');
    setShowTypeSelectDialog(false);
  }

  function handleTypeSelect(type) {

    // Deep copy
    let newObj = JSON.parse (JSON.stringify(objAttrs));
    newObj.typeId  = type.id;
    newObj.typeCode = type.code;

    setTypeSpecAttrs (typeSpecAttrList[type.code]);

    setObjAttrs(newObj);

    setErrMsg_TypeSelect('');
    setTypeSearchTerm('');
    setShowTypeSelectDialog(false);
  }

  const onTypeSearchInputChange = (e) => {
    setTypeSearchTerm(e.target.value);
  }

  function renderType(type, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "40%"}}>{type.code}</td>
        <td style={{width: "40%"}}>{type.description}</td>
        <td style={{width: "20%"}}>
          <Button size="tiny" variant="outline-secondary" style={{ float: 'left' }} onClick={() => handleTypeSelect(type)}>
            {t("I18N_Select")}
          </Button>
       </td>
      </tr>
    )
  }


  // --- Location select dialog stuff ---

  const handleLocPicker = (e, mode) => {
    setLocPickerMode(mode);
    setShowLocPickerDialog(true);
  }

  function handleLocPickerClose() {
    setShowLocPickerDialog(false);
  }

  function handleLocSelect(location) {

    // Deep copy
    let newObj = JSON.parse (JSON.stringify(objAttrs));

    if (locPickerMode === 'LOC') {
      newObj.locId   = location.id;
      newObj.locCode = location.code;
    } else if (locPickerMode === 'SERVICE_LOC') {
      newObj.serviceLocId   = location.id;
      newObj.serviceLocCode = location.code;
    }

    setObjAttrs(newObj);

    setShowLocPickerDialog(false);
  }


  // --- Upload Doc Related ---

/*
  function handleUploadDoc() {
  }

  function renderDocs(doc, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td style={{width: "40%"}}>{doc.name}</td>
        <td style={{width: "40%"}}>{doc.description}</td>
        <td style={{width: "40%"}}>{doc.type}</td>
        <td style={{width: "40%"}}>{doc.size}</td>
        <td style={{width: "40%"}}>{doc.timeAdded}</td>
        <td style={{width: "20%"}}>
       </td>
      </tr>
    )
  }
*/


  function renderTypeSpecAttrRowCreate(offset) {
    return (
      typeSpecAttrs.length > offset ?
        <>
          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
            { typeSpecAttrs[offset + 0] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 0] + "_u")}:</Col> : null }
            { typeSpecAttrs[offset + 1] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 1] + "_u")}:</Col> : <Col></Col> }
            { typeSpecAttrs[offset + 2] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 2] + "_u")}:</Col> : <Col></Col> }
            { typeSpecAttrs[offset + 3] ? <Col>{t("I18N_" + typeSpecAttrs[offset + 3] + "_u")}:</Col> : <Col></Col> }
          </Row>
          <Row className={classes.admin_pages__field_value}>
            { typeSpecAttrs[offset + 0] ?
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name={typeSpecAttrs[offset + 0]} value={objAttrs[typeSpecAttrs[offset + 0]]}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
              : null }
            { typeSpecAttrs[offset + 1] ?
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name={typeSpecAttrs[offset + 1]} value={objAttrs[typeSpecAttrs[offset + 1]]}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
              : <Col></Col> }
            { typeSpecAttrs[offset + 2] ?
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name={typeSpecAttrs[offset + 2]} value={objAttrs[typeSpecAttrs[offset + 2]]}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
              : <Col></Col> }
            { typeSpecAttrs[offset + 3] ?
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name={typeSpecAttrs[offset + 3]} value={objAttrs[typeSpecAttrs[offset + 3]]}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
              : <Col></Col> }
          </Row>
        </>
        : null
    );
  }


  function isNaturalNumber(str) {
    str = '' + str; // If input is a number, convert to string.
    const n = Math.floor(Number(str));
    return ((n !== Infinity) && (String(n) === str) && (n >= 0));
  }

  //--- END ---

  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Asset")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px', maxHeight:'700px', overflowY:'auto'}}>
          <div display='flex'>
            <span>
              {t("I18N_Asset_info")}
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>

            <form>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Asset_type")}: *</Col>
                <Col>{t("I18N_Asset_code")}: *</Col>
                <Col>{t("I18N_Name")}: *</Col>
                <Col>{t("I18N_Name") + " (" + t("custom:I18N_Language_2") + ")"}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <input readOnly className={classes.admin_pages__field_editable} style={{width:'90%'}} name="typeCode" value={objAttrs.typeCode} />
                  <span onClick={handleTypePicker} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                    <SearchIcon size={14} />
                  </span>
                </Col>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="code" value={objAttrs.code}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="name" value={objAttrs.name}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="nameLang2" value={objAttrs.nameLang2}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Description")}: </Col>
                <Col>{t("I18N_Location")}:</Col>
                <Col>{t("I18N_Service_loc")}:</Col>
                { configInfo.uiConfig.visibleFields.ASSET_NativeCode ?
                  <Col>{t("I18N_Native_code")}:</Col>
                : <Col></Col>
                }
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <textarea className={classes.admin_pages__field_editable} style={{minWidth: '100%', minHeight:'65px', backgroundColor:'white'}}
                            name="description" value={objAttrs.description}
                    onChange={(e) => onAttrsInputChange(e)} />
                </Col>
                <Col>
                  <input readOnly className={classes.admin_pages__field_editable} style={{width:'90%'}} name="location" value={objAttrs.locCode}
                    onChange={(e) => onAttrsInputChange(e)} />
                  <span onClick={event => handleLocPicker(event, "LOC")} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                    <SearchIcon size={14} />
                  </span>
                </Col>
                <Col>
                  <input readOnly className={classes.admin_pages__field_editable} style={{width:'90%'}} name="serviceLoc" value={objAttrs.serviceLocCode}
                    onChange={(e) => onAttrsInputChange(e)} />
                  <span onClick={event => handleLocPicker(event, "SERVICE_LOC")} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                    <SearchIcon size={14} />
                  </span>
                </Col>
                { configInfo.uiConfig.visibleFields.ASSET_NativeCode ?
                  <Col>
                    <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="nativeCode" value={objAttrs.nativeCode}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                : <Col></Col>
                }
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Brand")}:</Col>
                <Col>{t("I18N_Model")}:</Col>
                <Col>{t("I18N_Model_num")}:</Col>
                <Col>{t("I18N_Serial_num")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="brand"     value={objAttrs.brand}     onChange={(e) => onAttrsInputChange(e)} /> </Col>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="model"     value={objAttrs.model}     onChange={(e) => onAttrsInputChange(e)} /> </Col>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="modelNum"  value={objAttrs.modelNum}  onChange={(e) => onAttrsInputChange(e)} /> </Col>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="serialNum" value={objAttrs.serialNum} onChange={(e) => onAttrsInputChange(e)} /> </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Mfr")}:</Col>
                <Col>{t("I18N_Website")}:</Col>
                <Col>{t("I18N_Country_of_orig")}:</Col>
                <Col>{t("I18N_Vendor")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="mfr"             value={objAttrs.mfr}             onChange={(e) => onAttrsInputChange(e)} /> </Col>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="website"         value={objAttrs.website}         onChange={(e) => onAttrsInputChange(e)} /> </Col>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="countryOfOrigin" value={objAttrs.countryOfOrigin} onChange={(e) => onAttrsInputChange(e)} /> </Col>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="vendor"          value={objAttrs.vendor}          onChange={(e) => onAttrsInputChange(e)} /> </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Length_mm")}:</Col>
                <Col>{t("I18N_Width_mm")}:</Col>
                <Col>{t("I18N_Height_mm")}:</Col>
                <Col>{t("I18N_Weight_kg")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="length" value={objAttrs.length}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="width"  value={objAttrs.width}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="height" value={objAttrs.height}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
                <Col> <input className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="weight" value={objAttrs.weight}
                             onChange={(e) => onAttrsInputChange(e)} /> </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Handover_date")}:</Col>
                <Col>{t("I18N_Install_date")}:</Col>
                <Col>{t("I18N_First_use_date")}:</Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <DateTimePicker onChange={onDatepickerChangeHandoverDate} value={handoverDate}
                    format={ (handoverDate != null) ? "y-MM-dd" : "y-MM-dd" }
                    disableClock="true"
                    clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                    calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                    locale={locale}
                  />
                </Col>
                <Col>
                  <DateTimePicker onChange={onDatepickerChangeInstallDate} value={installDate}
                    format={ (installDate != null) ? "y-MM-dd" : "y-MM-dd" }
                    disableClock="true"
                    clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                    calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                    locale={locale}
                  />
                </Col>
                <Col>
                  <DateTimePicker onChange={onDatepickerChangeFirstUseDate} value={firstUseDate}
                    format={ (firstUseDate != null) ? "y-MM-dd" : "y-MM-dd" }
                    disableClock="true"
                    clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                    calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                    locale={locale}
                  />
                </Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Warr_start_date")}:</Col>
                <Col>{t("I18N_Warr_end_date")}:</Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <DateTimePicker onChange={onDatepickerChangeWarrStartDate} value={warrStartDate}
                    format={ (warrStartDate != null) ? "y-MM-dd" : "y-MM-dd" }
                    disableClock="true"
                    clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                    calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                    locale={locale}
                  />
                </Col>
                <Col>
                  <DateTimePicker onChange={onDatepickerChangeWarrEndDate} value={warrEndDate}
                    format={ (warrEndDate != null) ? "y-MM-dd" : "y-MM-dd" }
                    disableClock="true"
                    clearIcon=<BiXCircle size={16} style={{color:"gray"}}/>
                    calendarIcon=<BiCalendar size={16} style={{color:"gray"}}/>
                    locale={locale}
                  />
                </Col>
                <Col></Col>
                <Col></Col>
              </Row>

              { typeSpecAttrs && typeSpecAttrs.length > 0 ?
                  <>
                    <hr className="solid" style={{ marginTop: '15px' }}></hr>

                    {renderTypeSpecAttrRowCreate(0)}
                    {renderTypeSpecAttrRowCreate(4)}
                    {renderTypeSpecAttrRowCreate(8)}
                    {renderTypeSpecAttrRowCreate(12)}

                    <hr className="solid" style={{ marginTop: '15px' }}></hr>
                  </>
                : null
              }

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Status")}: *</Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                    title={ !objAttrs.status || (objAttrs.status === '') ? t("common:I18N_DROPDOWN_PROMPT") : t("common:I18N_ST_" + objAttrs.status)}
                    onSelect={onAssetStatusSelect}>
                    {statusList.map((item, index) => {
                      return (
                        <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                          {t("common:I18N_ST_" + item.value)}
                        </Dropdown.Item>
                      );
                    })}
                  </DropdownButton>
                </Col>
                <Col></Col>
                <Col></Col>
                <Col></Col>
              </Row>

            </form>
          </Container>

        </div>

{/*
        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Documents")}
            </span>

            <span style={{marginLeft:'auto', marginRight:'20px'}}>
              <OverlayTrigger overlay={<Tooltip id="tooltip-new_role" style={{fontSize:'11px'}}>{t("I18N_TIP_Upload_doc")}</Tooltip>}>
                <span onClick={handleUploadDoc} style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <BiPlus size={18} />
                </span>
              </OverlayTrigger>
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

            <Table hover responsive size="sm">
              <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                <tr>
                  <th style={{width:'20%', fontWeight:'400'}}>{t("I18N_Doc_name")}</th>
                  <th style={{width:'40%', fontWeight:'400'}}>{t("I18N_Description")}</th>
                  <th style={{width:'15%', fontWeight:'400'}}>{t("I18N_File_type")}</th>
                  <th style={{width:'15%', fontWeight:'400'}}>{t("I18N_File_size")}</th>
                  <th style={{width:'20%', fontWeight:'400'}}>{t("I18N_Time_added")}</th>
                  <th style={{width:'5%'}}></th>
                </tr>
              </thead>
              <tbody>
                {(docList && docList.length > 0) ? docList.map(renderDocs) : null}
              </tbody>
            </Table>
          </div>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>
*/}

        <Row className={classes.admin_pages__field_label} style={{marginTop:'20px', fontStyle:'italic'}}>
          <span>{t("I18N_Req_fields")}</span>
        </Row>

        <div className={classes.admin_pages__page_subtitle} style={{ marginTop: '0px' }}>
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleCreateCancel}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleCreateSubmit}>
                {t("I18N_Submit")}
              </Button>
            </div>
            <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
              {errMsg}
            </span>
          </Form.Group>
        </div>


        <Modal show={showTypeSelectDialog} onHide={handleTypeSelectCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span>
                {t("I18N_Type_picker")}
              </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Code")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>
                    <Form onSubmit={handleTypeSearch}>
                      <Form.Control style={{ fontSize: '12px', height:'22px' }} type="text" name="typeSearchTerm" value={typeSearchTerm}
                                    onChange={(e) => onTypeSearchInputChange(e)} />
                    </Form>
                  </Col>
                  <Col>
                    <span onClick={handleTypeSearch} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                      <SearchIcon size={14} />
                    </span>
                  </Col>
                </Row>

                <hr className="solid" style={{ margin: '10px 0 10px 0' }}></hr>

                <div style={{overflowY:'scroll', fontSize:'11px', marginTop:'10px', maxHeight:'600px'}}>
                  <Table hover responsive size="sm">
                    <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                      <tr>
                        <th style={{fontWeight:'400'}}>{t("I18N_Code")}</th>
                        <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {(typeList && typeList.length > 0) ? typeList.map(renderType) : null}
                    </tbody>
                  </Table>
                </div>

                <Row>
                  <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                    {errMsg_TypeSelect}
                  </span>
                </Row>
                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleTypeSelectCancel}>
                      {t("I18N_Close")}
                    </Button>
                  </div>
                </Row>
            </div>
          </Modal.Body>
        </Modal>


        <LocPickerDialog
          show={showLocPickerDialog}
          handleObjSelect={handleLocSelect}
          onClose={handleLocPickerClose}
        />

      </Card>
    </>
  );
}

export default AssetAdminNewView;
